import { CompanyInformationState } from "../types";

const state: CompanyInformationState = {
  zipcode: null,
  city: "",
  addressLine1: "",
  addressLine2: "",
  websiteUrl: "",
  country: "",
  billingContactName: "",
  billingContactEmail: "",
  name: "",
};

export default state;
